"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
  之后票属性按钮状态的地方在此维护，有改到就加
*/
var BUTTONSTATUS;
(function (BUTTONSTATUS) {
    // 预售
    BUTTONSTATUS[BUTTONSTATUS["PRESALE"] = 2] = "PRESALE";
    // 售票中
    BUTTONSTATUS[BUTTONSTATUS["ONSALE"] = 3] = "ONSALE";
    // 售罄 预售
    BUTTONSTATUS[BUTTONSTATUS["SELLOUTPRE"] = 4] = "SELLOUTPRE";
    // 售罄 售票中
    BUTTONSTATUS[BUTTONSTATUS["SELLOUT"] = 5] = "SELLOUT";
})(BUTTONSTATUS || (BUTTONSTATUS = {}));
exports.default = BUTTONSTATUS;
